import ol = require("ol");
import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import $ = require("jquery");
import Query = require("arcgis/services/featureserver/query");
import Mediator = require("../mediator");
import JSV = require("../utils/jsv");
import Base = require("./base/geoquery");

import Services = require("../services/ogc/wfs-readers");

interface ShowInfoArgs {
    point?: ol.Coordinate;
    box?: ol.Coordinate;
    pixel?: ol.Pixel;
    layers?: Rhythm.GIS.FeatureQueryResultLayer[];
};

interface LocatorArgs {
    location: string;
}

class Command extends Base<{ out: any }> {

    static about = `Uses the WfsGetFeatureReader in ogc/wfs-readers to locate a feature in a WFS service`;

    static options = Utils.defaults({
        "event": {
            default: "geoquery-result"
        },
        "key-template": {
            default: "<%=OBJECTID%>"
        },
        "typeName": {
            about: "passes through to the WfsGetFeatureReader",
        },
        "query-service": {
            about: "url to query"
        },
        "service-query-template": {
            about: "filter template"
        },
    }, Base.options);

    execute(args = this.args) {
        var options = _.defaults(this.asOptions(Command.options), {
        });

        if (args.out.location) return this.executeLocator(<LocatorArgs>args.out);
        return this.executeShowInfo(<ShowInfoArgs>args.out);
    }

    private executeLocator(args: ShowInfoArgs | LocatorArgs) {

        var options = this.options;

        Utils.ifOption(options, "typeName", typeName => {
            Utils.ifOption(options, "query-service", url => {
                Utils.ifOption(options, "service-query-template", queryTemplate => {
                    let filter = JSV.parse(_.template(queryTemplate)(args))["filter"];
                    let data = [[filter["property"], filter["value"]]];

                    // {filter:{property:STATE_ABBR, value:<%=location%>}}
                    Services.WfsGetFeatureReader.read({
                        url: url,
                        typeName: typeName,
                        filter: data
                    }).done(layer => {
                        this.assignKeys(layer);

                        this.trigger({
                            layers: [layer]
                        });

                    });
                });

            });
        });

    }

    private executeShowInfo(args: ShowInfoArgs) {
        var serviceInfo = this.options;

        Utils.ifOption(serviceInfo, "typeName", typeName => {
            Utils.ifOption(serviceInfo, "query-service", url => {

                Services.WfsGetFeatureReader.query({
                    url: url,
                    typeName: typeName,
                    geometry: args.box
                }).done(layer => {
                    this.assignKeys(layer);
                    this.trigger({
                        serviceInfo: serviceInfo,
                        layers: [layer]
                    });

                });
            });

        });

    }

}

export = Command;